import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ChevronLeft, Lock } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useUserAuth } from "../components/UserAuthContext";
import { useNavigate } from "react-router-dom";
import CustomHead from '../components/CustomHead';
import TeseoPlusBanner from '../components/TeseoPlusBanner';
import VideoPlayer from '../components/VideoPlayer';
import api from "../API/backend";
import TButton from '../components/TButton';
import lock from "../images/icons/lock.png";
import schoolr_logo from "../images/logo/schoolr_logo.png";
import teseo_logo from "../images/logo/logo_white.svg";


async function fetchLessonData(lessonId) {
    try {
        const res = await api.get(`${process.env.REACT_APP_BACKEND_PATH}/lessons/${lessonId}`, {});
        if (res.status === 200) {
            return res.data;
        } else if (res.status === 403) {
            return null;
        }
    } catch (error) {
        console.error('Error fetching lesson content:', error);
        return null;
    }
}

const Lezione = () => {
    const { lessonId } = useParams();
    const { userData } = useUserAuth();
    const [videoUrl, setVideoUrl] = useState(null);
    const [lessonData, setLessonData] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const userType = userData?.type;

    const handleGoBack = () => {
        window.history.back();
    };

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchLessonData(lessonId);
            if (data) {
                setVideoUrl(data.link);
                setLessonData(data.data);
            } else {
                setLessonData(null);
            }
            setLoading(false);
        };
        fetchData();
    }, [lessonId]);

    return (
        <main className="App">
            <CustomHead
                title="Teseo.app | Lezione"
                description="Lezioni di latino e greco."
                keywords="teseo.app, teseo, latino, greco, traduzione, analisi, versione, lezioni"
                author="Teseo"
                canonicalUrl="https://teseo.app/lezioni"
            />

            <Container className='pt-20'>
                <Row className='my-5 justify-content-start d-flex align-items-center'>
                    <Col xs="auto">
                        <ChevronLeft className='white' size={40} onClick={handleGoBack} style={{ cursor: 'pointer' }} />
                    </Col>
                    <Col xs="auto">
                        <Row>
                            <span className='bolder fontXXL white'>
                                {lessonData ? lessonData.title : 'Lezione'}
                            </span>
                        </Row>
                        {lessonData && (
                            <Row>
                                <span className='fontL white'>{lessonData.description}</span>
                            </Row>
                        )}
                    </Col>
                </Row>
                <Row className="my-4 justify-content-center align-items-center">
                    <Col xs="auto">
                        <div className="flex items-center">
                            <img src={teseo_logo} alt="Logo" style={{ height: '40px' }} />
                            {/* <span className="regular fontXL mx-2">Teseo.app</span> */}
                        </div>
                    </Col>
                    <Col xs="auto">
                        <span className="white fontXL">×</span>
                    </Col>
                    <Col xs="auto">
                        <a href="https://schoolr.net" target="_blank" rel="noopener noreferrer">
                            <img src={schoolr_logo} alt="Schoolr Logo" style={{ height: '40px', cursor: 'pointer' }} />
                        </a>
                    </Col>
                </Row>
                <Row className='mb-5 justify-content-center d-flex align-items-center text-center'>
                    {lessonData === null ? (
                        <>
                            <img src={lock} alt="Lock Icon" className="mb-4" style={{ width: '170px', height: '150px' }} />
                            <h2 className="fontXL mb-2">Questa lezione è riservata agli utenti Teseo+</h2>
                            <p className='mb-4'>Abbonati per accedere a contenuti esclusivi.</p>
                            <TButton onClick={() => navigate("/pay")} text='Scopri i piani!'></TButton>
                        </>
                    ) : (
                        <>
                            {loading ? (
                                <div
                                    style={{
                                        width: '100%',
                                        height: '600px',
                                        backgroundColor: 'black',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: 'white',
                                        fontSize: '24px',
                                    }}
                                >
                                    Caricamento...
                                </div>
                            ) : (
                                <VideoPlayer videoUrl={videoUrl || null} />
                            )}
                        </>
                    )}
                </Row>
            </Container>

            {userType === "normal" && (
                <Container className='pt-40'>
                    <TeseoPlusBanner />
                </Container>
            )}
        </main>
    );
};

export default Lezione;